enum AccountOptionType {
  CUSTOMER_CSV_EXPORT = "CUSTOMER_CSV_EXPORT",
  EMAIL_SEND_LIMIT_UNLIMITED = "EMAIL_SEND_LIMIT_UNLIMITED",
  EMAIL_SEND_LIMIT_1000 = "EMAIL_SEND_LIMIT_1000",
  EMAIL_SEND_LIMIT_500 = "EMAIL_SEND_LIMIT_500",
  RESERVATION = "RESERVATION",
  RECORD = "RECORD",
}

export default AccountOptionType;
